function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "back-arrow",
  transform: "translate(-271.226 -47.259)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_473",
  "data-name": "Grupo 473"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1389",
  "data-name": "Ret\\xE2ngulo 1389",
  width: 15.408,
  height: 0.842,
  transform: "translate(271.818 52.336)",
  fill: "#00a9ff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_474",
  "data-name": "Grupo 474"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_837",
  "data-name": "Caminho 837",
  d: "M276.66,58.258l-5.433-5.434,5.43-5.566.6.588-4.849,4.971,4.845,4.845Z",
  fill: "#00a9ff"
})));

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.629bbc44.svg";
export { ForwardRef as ReactComponent };